import { ofType } from "redux-observable";
import { EMPTY } from "rxjs";
import { ajax } from "rxjs/ajax";
import { catchError, filter, ignoreElements, retry, switchMap } from "rxjs/operators";
import { IdTrackingAppsflyer } from "../../../constants/IdTrackingAppsflyer";
import { selectAppsflyerData } from "../../../selectors/selectAppsflyerData";
import { errorNetworkOut } from "../../../utils/logging/logging";
import { TypeActionAppsflyer } from "../actionAppsflyer";
var url = IdTrackingAppsflyer.Url;
var headers = IdTrackingAppsflyer.Header;
export var epicAppsflyerUpdate = function (action$, state$, deps) {
    return action$.pipe(ofType(TypeActionAppsflyer.Update), filter(function () {
        var state = state$.value;
        return state.playerSettingsInfo.mobileTrackingId !== undefined;
    }), switchMap(function (action) {
        var state = state$.value;
        var data = selectAppsflyerData(state, action.eventName, action.eventValue || {});
        return ajax({
            async: true,
            body: JSON.stringify(data),
            crossDomain: true,
            headers: headers,
            method: "POST",
            url: url,
        });
    }), retry(), catchError(function (err) {
        errorNetworkOut("Appsflyer catchError: " + err);
        return EMPTY;
    }), ignoreElements());
};



//////////////////
// WEBPACK FOOTER
// ./src/features/appsflyer/epics/epicAppsflyerUpdate.ts
// module id = 1777
// module chunks = 3